@if (control) {
  <mat-form-field>
    <label
      [for]="inputId"
      [ngClass]="{ 'text-red': control.invalid && (control.dirty || control.touched) }"
    >
      <span
        >{{ label() }}
        @if (isRequired && !hideRequiredMarker()) {
          <span class="required">*</span>
        }
      </span>
      @if (labelLink()) {
        <a
          class="small"
          tabindex="0"
          (click)="labelLinkClick.emit()"
          (keydown.enter)="labelLinkClick.emit()"
          >{{ labelLink() }}</a
        >
      }
    </label>

    <div class="password-input-wrapper">
      <input
        matInput
        [id]="inputId"
        [type]="inputType"
        [autocomplete]="autocompleteComputed()"
        [formControl]="control"
        [pattern]="patternComputed()"
        [readonly]="readonly()"
        [placeholder]="placeholder()"
      />
      <lib-icons
        class="visibility-toggle"
        [icon]="hide ? 'eye' : 'eye-slash'"
        role="button"
        tabindex="0"
        [attr.aria-label]="hide ? 'Show password' : 'Hide password'"
        (click)="toggleVisibility()"
        (keydown.enter)="toggleVisibility()"
        (keydown.space)="toggleVisibility(); $event.preventDefault()"
      ></lib-icons>
    </div>

    @if (showError) {
      <mat-error>{{ getErrorMessage(errorKeys[0]) }}</mat-error>
    }
  </mat-form-field>
}
